import { useStrategies } from '../../../hooks/useStrategies';

export const usePassiveScansData = () => useStrategies('passive');
